import React from 'react';
import { Navigate } from 'react-router-dom';
import { LazyPage } from '@hocs';
import { Routes } from '@enums';
import { jsx as _jsx } from "react/jsx-runtime";
var ErrorPage = LazyPage('error', 'ErrorPage');
var LoginPage = LazyPage('login', 'LoginPage');
var PasswordRecoveryPage = LazyPage('password-recovery', 'PasswordRecoveryPage');
var ChangePasswordPage = LazyPage('change-password', 'ChangePasswordPage');
var RegistrationPage = LazyPage('registration', 'RegistrationPage');
var NotFoundPage = LazyPage('not-found', 'NotFoundPage');
var InfoPage = LazyPage('info', 'InfoPage');
var LendingUnsubscribePage = LazyPage('lending-unsubscribe', 'LendingUnsubscribePage');
var appPublicRoutes = [{
  name: Routes.All,
  path: Routes.All,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.NotFound,
    replace: true
  }),
  index: false
}, {
  name: Routes.Main,
  path: Routes.Main,
  element: /*#__PURE__*/_jsx(Navigate, {
    to: Routes.Login,
    replace: true
  }),
  index: false
}, {
  name: Routes.Login,
  path: Routes.Login,
  element: /*#__PURE__*/_jsx(LoginPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.PasswordRecovery,
  path: Routes.PasswordRecovery,
  element: /*#__PURE__*/_jsx(PasswordRecoveryPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.ChangePassword,
  path: Routes.ChangePassword,
  element: /*#__PURE__*/_jsx(ChangePasswordPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Registration,
  path: Routes.Registration,
  element: /*#__PURE__*/_jsx(RegistrationPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.NotFound,
  path: Routes.NotFound,
  element: /*#__PURE__*/_jsx(NotFoundPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Info,
  path: Routes.Info,
  element: /*#__PURE__*/_jsx(InfoPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.ConfirmEmail,
  path: Routes.ConfirmEmail,
  element: /*#__PURE__*/_jsx(InfoPage, {}),
  index: false,
  inline: true
}, {
  name: Routes.LendingUnsubscribe,
  path: Routes.LendingUnsubscribe,
  element: /*#__PURE__*/_jsx(LendingUnsubscribePage, {}),
  index: false,
  inline: true
}, {
  name: Routes.Error,
  path: Routes.Error,
  element: /*#__PURE__*/_jsx(ErrorPage, {}),
  index: false
}];
export { appPublicRoutes };